export const goToRoute = type => ({
  type,
});



// WEBPACK FOOTER //
// ./application/actions/routeActions.js